import React, {Component} from 'react';
import './Experience.css';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Button from 'react-bootstrap/Button';

const popoverCurrent = (
    <Popover id="popover-current" style={{maxWidth: "500px"}}>
      <Popover.Title as="h3">Roles and Responsibilities</Popover.Title>
      <Popover.Content>
        <ul>
            <li>Used Java 8 features such as Lambda expressions and streaming APIs for the development of services.</li>
            <li>Created various REST APIs in Java.</li>
            <li>Wrote various DAO classes and functionalities to interact efficiently with the database using JDBI connector.</li>
            <li>Used PostgreSQL to write stored procedures, functions, and SQL queries for interacting with Aurora database.</li>
            <li>Created various backend services which interacted via PulsarQ messages.</li>
            <li>Worked with business stakeholders to understand requirements and write efficient solutions.</li>
            <li>Used JUnit and Mockito framework for writing effective tests.</li>
            <li>Participated in multi-application and multi-organization integration testing sessions.</li>
            <li>Tested various REST APIs using Postman, service calls, and data bindings.</li>
            <li>Worked on GitHub and Bitbucket for source code management and repository workflows.</li>
        </ul>
      </Popover.Content>
    </Popover>
  );


const popover1 = (
    <Popover id="popover-basic" style={{maxWidth: "500px"}}>
      <Popover.Title as="h3">Roles and Responsibilities</Popover.Title>
      <Popover.Content>
        <ul>
            <li>Created various Rest API’s using Spring Boot. Also used Spring JPA/Hibernate for the database connectivity with SQL Server database.</li>
            <li>Created single page application structure with multiple modules using ReactJS, JavaScript</li>
            <li>Implemented the online portal for customers using ReactJS and Spring-Boot. It provided them the functionality of accessing their daily transactions reports.</li>
            <li>Created core modules and components which included Navbar, Toolbar, services and Routing</li>
        </ul>
      </Popover.Content>
    </Popover>
  );

  const popover2 = (
    <Popover id="popover-basic" style={{maxWidth: "500px"}}>
      <Popover.Title as="h3">Roles and Responsibilities</Popover.Title>
      <Popover.Content>
        <ul>
            <li>Developed user interfaces using JSP, Struts, AJAX, JSTL and JavaScript.</li>
            <li>Implemented Spring MVC framework for developing J2EE web based application.</li>
            <li>Communicated with Business Architects on a regular basis to analyse the requirements and for the preparation of detailed BRD (business Requirement document).</li>
            <li>Created Spring services, controllers and DAO’s to achieve dependency injection.</li>
            <li>Used Hibernate 3.0 in data access layer for accessing and updating database.</li>
            <li>Integrated Spring and Hibernate ORM framework for persistence and used Hibernate DAO Support with Hibernate Template to access the data</li>
            <li>Implemented caching techniques, wrote POJO classes for storing data and DAO's to retrieve the data and other database configurations using Hibernate.</li>
            <li>Wrote SQL scripts to write database calls.</li>
        </ul>
      </Popover.Content>
    </Popover>
  );

class Experience extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="divExperienceStyle">
                <div className="divAboutMeHeader" >
                   <h1 >  Experience </h1>
                   <hr className="solid"></hr>
                </div>
                <div>
                <VerticalTimeline>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="Mar, 2021 - present"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}>
                        <h3 className="vertical-timeline-element-title">Senior Engineer</h3>
                        <h3 className="h3Experience">Lineage Logistics/ Cognizant</h3>
                        <h4 className="vertical-timeline-element-subtitle">Charlotte, NC</h4>
                        <h5 className="h5ExperienceDate">Mar, 2021 - present</h5>
                        <p>
                        Automating real-time applications for IoT devices. This state-of-the-art project involves automating large-capacity cold storage warehouses. The application serves as the backend for providing instructions to conveyors, pulleys, and IoT devices, delivering multi-million dollar benefits to clients through improved productivity, supply chain performance, and warehouse efficiency.<br/>
                        <OverlayTrigger trigger="click" placement="right" overlay={popoverCurrent}>
                        <Button className="button-experience-responsibilities">View full Responsibilities</Button>
                        </OverlayTrigger>
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="Oct, 2014 - Jun, 2018"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}>
                        <h3 className="vertical-timeline-element-title">Technology Analyst</h3>
                        <h3 className="h3Experience">WellsFargo/Infosys</h3>
                        <h4 className="vertical-timeline-element-subtitle">Charlotte, NC</h4>
                        <h5 className="h5ExperienceDate">Oct, 2014 - Jun, 2018</h5>
                        <p>
                        Develop Rich prototypes, Tools & Subroutines, Single Page Applications, Analyze High Volume Daily Transaction Feeds and provide scalable designs.<br/>
                        <OverlayTrigger trigger="click" placement="right" overlay={popover1}>
                        <Button className="button-experience-responsibilities">View full Responsibilities</Button>
                        </OverlayTrigger>
                        </p>
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="Sep, 2008 - Sep, 2014"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    >
                        <h3 className="vertical-timeline-element-title">Software Developer</h3>
                        <h3 className="h3Experience">Infosys Ltd</h3>
                        <h4 className="vertical-timeline-element-subtitle">Pune, India</h4>
                        <h5 className="h5ExperienceDate">Sep, 2008 - Sep, 2014</h5>
                        <p>
                        Develop RESTFul services, Create responsive web applications, database designs, Spring framework, Full stack development.<br/>
                        <OverlayTrigger trigger="click" placement="left" overlay={popover2}>
                            <Button className="button-experience-responsibilities">Roles and Responsibilities</Button>
                        </OverlayTrigger>
                        </p>
                    </VerticalTimelineElement>
                    </VerticalTimeline>
                </div>
                
            </div>
         );
    }
}
 
export default Experience;
